import {Component, Input} from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import {ModalController, NavParams} from '@ionic/angular';
import {General} from '../../util/general';
import {Order} from '../../models/order';
import {Components} from '@ionic/core';

@Component({
    selector: 'emc-order-resume',
    templateUrl: 'order-resume.html',
    styleUrls: ['order-resume.scss']
})
export class OrderResumeComponent {

    order: Order;
    optionsDisplay: Array<any>;
    total: number;
    subtotal: number;
    deliveryTax: number;
    deliveryDate: string;
    @Input() modal: Components.IonModal;

    constructor(public viewCtrl: ModalController, public params: NavParams, public modalCtrl: ModalController) {

        moment.locale('pt');
        this.order = params.get('order');
        this.deliveryDate = moment(this.order.arrivalExpectedAt).format('LLLL');
        this.optionsDisplay = Array();

        let itemIndex = 0;
        this.order.orderItems.forEach((item) => {
            this.optionsDisplay.push(General.optimizeOptions(item.optionsSelected));
            if (this.optionsDisplay[itemIndex]) {
                this.optionsDisplay[itemIndex] = this.optionsDisplay[itemIndex].filter((options) => {
                    return options.options.length !== 0;
                });
            }
            itemIndex ++;
        });

        console.log('order', this.order);
    }

    dismiss() {
        this.modal.dismiss('cancel');
    }
}
